export var BackedByCategory;
(function (BackedByCategory) {
    BackedByCategory["BACKED_BY_CATEGORY_EON"] = "EON";
    BackedByCategory["BACKED_BY_CATEGORY_OTHER"] = "OTHER";
    BackedByCategory["BACKED_BY_CATEGORY_NONE"] = "NONE";
    BackedByCategory["BACKED_BY_CATEGORY_EXCLUDED"] = "EXCLUDED";
    BackedByCategory["BACKED_BY_CATEGORY_CLASSIFICATION_IN_PROGRESS"] = "CLASSIFICATION_IN_PROGRESS";
})(BackedByCategory || (BackedByCategory = {}));
